import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.hit_percentage',
    modules: [
        R,
    ],
})
@Service('HitPercentageStore')
export default class HitPercentageStore extends BaseStore {
    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('hit-percentages');
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/hit_percentage.js